module.exports = __webpack_public_path__ + "img/kgjh_logo.87f04361.png";